module.exports = __webpack_public_path__ + "img/about-me.b37ba6ba.jpg";